export default __webpack_public_path__ + "static/rewards.url-283bfdc530beb0364f5021bcb8fa605e.svg";